import { Pipe, PipeTransform } from '@angular/core';
import { CommonNumberFormatterPipe } from './common-number-formatter.pipe';

@Pipe({
	name: 'commonPercentFormatter',
})
export class CommonPercentFormatterPipe implements PipeTransform {
	constructor (
		private numberFormatter: CommonNumberFormatterPipe,
	) {}

	transform(num: number) {
		return this.numberFormatter.transform(num, '%');
	}
}
